import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store, select } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { SharedService } from 'app/shared.service';
import { CatPais } from 'app/shared/enum.shared';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState, selectUtilsState } from 'app/store/app.states';
import { Observable, map, startWith } from 'rxjs';

export interface IContenedorMaritimo {
    Index: string;
    Id: number;
    TipoContenedor: number;
    MatriculaContenedor: string;
    NumPrecinto: string;
}

@Component({
    selector: 'app-maritimo',
    templateUrl: './maritimo.component.html',
    styleUrls: ['./maritimo.component.scss']
})
export class MaritimoComponent implements OnInit {
    countContenedor: IContenedorMaritimo[] = [];
    removeDisabledContenedor: boolean = true;

    FormMaritimo: FormGroup;
    lstContenedor: IContenedorMaritimo[] = [];
    catContenedores: any[] = [];
    defualtContenedor: IContenedorMaritimo = { Index: `ContenedorMaritimo${this.countContenedor.length + 1}`, Id: 0, TipoContenedor: 0, MatriculaContenedor: null, NumPrecinto: null };

    idEmpresa: number = 0;
    empresaData: any;
    tipoTransporte: any[] = [];
    catPermSCT: any[] = [];
    catTipoEmbarcacion: any[] = [];
    catTipoCarga: any[] = [];
    catAutoNaviero: any[] = [];
    paises: any[] = [];
    filteredNacionalidad: Observable<any>;
    anioPattern = /^[1-9]\d{3}$/;
    submitted: boolean = false;

    formContenedores: any[] = [];

    constructor(
        private formBuilder: FormBuilder,
        private sharedService: SharedService,
        private _snackBar: MatSnackBar,
        private store: Store<AppState>,
        private srvcoal: CoalService
    ) {
        this.FormMaritimo = this.formBuilder.group({
            Transporte: [0],
            PermSCT: [null],
            NumPermisoSCT: [null],
            NombreAseg: [null],
            NumPolizaSeguro: [null],
            TipoEmbarcacion: [null, Validators.required],
            Matricula: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
            NumeroOMI: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
            AnioEmbarcacion: [null, [Validators.minLength(4), Validators.maxLength(4), Validators.min(4), Validators.pattern(this.anioPattern)]],
            NombreEmbarc: [''],
            NacionalidadEmbarc: ['', Validators.required],
            UnidadesDeArqBruto: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(50)]],
            TipoCarga: [null, Validators.required],
            NumCertITC: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(50)]],
            Eslora: [null],
            Manga: [null],
            Calado: [null],
            LineaNaviera: [null],
            NombreAgenteNaviero: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(60)]],
            NumAutorizacionNaviero: [null, Validators.required],
            NumViaje: [null],
            NumConocEmbarc: [null]
        });
    }

    async ngOnInit(): Promise<void> {
        //Init Catalogos
        this.getCatPermSCT();
        this.getDirPais();
        this.empresaData = await this.getEmpresa();
        this.idEmpresa = this.empresaData.id || 0;
        this.getCatContenedores();
        const rt = await this.getCatTipoTransporte();
        this.getCatTipoEmbarcacion();
        this.getCatTipoCarga();
        this.getCatAutoNaviero();

        this.FormMaritimo.valueChanges.subscribe(changes => {
            if (this.FormMaritimo.valid) {
                this.sharedService.setFormMaritimo(changes);
            }
        });

        this.sharedService.maritimoContenedorForm$.subscribe(valores => {
            const index = this.lstContenedor.findIndex(item => item && item.Index === valores.Index);
            if (index === -1) {
                if (valores) this.lstContenedor.push(valores);
            } else {
                if (valores) this.lstContenedor[index] = valores;
            }
            //this.FormMaritimo.controls.Contenedor.setValue(this.lstContenedor);
        });

        //Paises Change
        let mexico = this.paises?.find(x => x.id == CatPais.Mexico);
        //Defualt     
        this.paisesInput.setValue(mexico || null);
        this.filteredNacionalidad = this.paisesInput.valueChanges.pipe(
            startWith(''),
            map(value => {
                const name = typeof value === 'string' ? value : value?.name;
                return name ? this._filterPais(name as string) : this.paises.slice();
            }),
        );
    }

    //Agregar formulario
    addContenedor = (contenedor: IContenedorMaritimo = this.defualtContenedor) => {
        contenedor.Index = `ContenedorMaritimo${this.countContenedor.length + 1}`;
        this.countContenedor.push(contenedor);
        this.countContenedor.length <= 0 ? this.removeDisabledContenedor = true : this.removeDisabledContenedor = false;
    };

    //Remover formulario
    removeContenedor = () => {
        this.countContenedor.splice(-1);
        this.countContenedor.length <= 0 ? this.removeDisabledContenedor = true : this.removeDisabledContenedor = false;
    };

    // convenience getter for easy access to form fields
    get f() { return this.FormMaritimo.controls; }
    get paisesInput() { return this.FormMaritimo.get('NacionalidadEmbarc'); }

    private _filterPais(value: string): any {
        const filterValue = value.toLowerCase();
        return this.paises.filter(option => option.attributes.idPais.toLowerCase().includes(filterValue) || option.attributes.nombre.toLowerCase().includes(filterValue));
    }

    displayFnNacionalidad(pais: any): string {
        if (pais?.attributes)
            return '' + pais?.attributes.idPais + '-' + pais?.attributes?.nombre;
        else
            return '';
    };

    changePais(value: string) {
        //console.log("🚀 ~ MaritimoComponent ~ changePais ~ value:", value);

    }

    getEmpresa(): Promise<any> {
        return new Promise<any>(resolve => {
            this.store.pipe(select(selectUtilsState)).subscribe((info: any) => {
                let empresa = info?.empresaSeleccionada || null;
                resolve(empresa);
            });
        });
    }

    getCatPermSCT() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService('cat-perm-scts?populate=*&pagination[start]=0&pagination[limit]=300').subscribe(
            (res: any) => {
                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {
                    this.catPermSCT = res.data || [];
                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

    getCatContenedores() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`cat-tipo-contenedores?populate=*&pagination[start]=0&pagination[limit]=300`).subscribe(
            (res: any) => {
                //console.log("🚀 ~ MaritimoComponent ~ getCatContenedores ~ res:", res)

                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {
                    this.catContenedores = res?.data || [];
                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

    getCatTipoTransporte(): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            this.store.dispatch(MostrarSpinner());
            this.srvcoal.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate[fac_porte_maritimos][populate]=*`).subscribe(
                (res: any) => {
                    //console.log("🚀 ~ MaritimoComponent ~ getCatTipoTransporte ~ res:", res)
                    this.store.dispatch(OcultarSpinner());
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                        );
                    } else {
                        let data: any[] = res?.data || [];
                        //if(data.length > 0)
                        this.tipoTransporte = data[0]?.attributes?.fac_porte_maritimos?.data || [];
                    }
                    resolve(true);
                },
                (error: any) => {
                    this.store.dispatch(OcultarSpinner());
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    resolve(false);
                });
        });
    }

    getCatTipoEmbarcacion() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`cat-tipo-embarcaciones?populate=*&pagination[start]=0&pagination[limit]=300`).subscribe(
            (res: any) => {
                //console.log("🚀 ~ MaritimoComponent ~ getCatTipoEmbarcacion ~ res:", res)
                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {
                    this.catTipoEmbarcacion = res?.data || [];
                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

    getDirPais() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService('dir-paises?populate=*&pagination[start]=0&pagination[limit]=300').subscribe(
            (res: any) => {
                //console.log("🚀 ~ TiposFiguraComponent ~ getDirPais ~ res:", res)
                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {
                    this.paises = res.data || [];
                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

    getCatTipoCarga() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`cat-tipo-cargas?populate=*&pagination[start]=0&pagination[limit]=300`).subscribe(
            (res: any) => {
                //console.log("🚀 ~ MaritimoComponent ~ getCatTipoCarga ~ res:", res)

                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {
                    this.catTipoCarga = res?.data || [];
                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

    getCatAutoNaviero() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`cat-auto-navieros?populate=*&pagination[start]=0&pagination[limit]=300`).subscribe(
            (res: any) => {
                //console.log("🚀 ~ MaritimoComponent ~ getCatAutoNaviero ~ res:", res)

                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {
                    this.catAutoNaviero = res?.data || [];
                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

    changeTipoTransporte(value) {
        //console.log("🚀 ~ MaritimoComponent ~ changeTipoTransporte ~ value:", value)

        let valor = Number(value || 0);
        if (valor > 0) {//Buscar transporte por id
            this.getMaritimoSeleccionado(valor);

        } else {//limpiar formulario
            this.FormMaritimo.reset();
            this.f['Transporte'].setValue(0);
            this.lstContenedor = [];
            this.countContenedor = [];
        }

    }

    async deleteTipoMaritimo() {

        let idTypeTransport = this.FormMaritimo.value.Transporte || 0;
        //Existe valor seleccionado
        if (idTypeTransport > 0) {

            //Eliminacion Logica de Contenedores
            if (this.lstContenedor.length > 0) {
                for await (const item of this.lstContenedor) {
                    if (item.Id > 0) {//draft
                        const res = await this.logicalDeleteContenedor(item.Id);
                    }
                }
            }

            //Eliminacion Logica de Tipo Maritimo seleccionado
            const result = await this.logicalDeleteTipoMaritimo(idTypeTransport);

            //Actualizando relacion en OpeEmpresa
            this.tipoTransporte.splice(
                this.tipoTransporte.find((item, index) => {
                    if (item.id == idTypeTransport)
                        return index
                }), 1
            );
            //Update ope OpeEmpresa     
            const resultEmpresa = await this.updateEmpresaTrasportes();
            //Refresh...
            const ls = await this.getCatTipoTransporte();

            //limpiar formulario
            this.FormMaritimo.reset();
            this.f['Transporte'].setValue(0);
            this.lstContenedor = [];
            this.countContenedor = [];

        }

    }

    async saveOrUpdateTipoMaritimo(): Promise<boolean> {

        return new Promise<boolean>(async (resolve) => {

            //this.submitted = true;
            if (this.FormMaritimo.valid) {
                //Forms contenedores
                this.formContenedores=[];
                if (this.lstContenedor.length > 0) {
                    //Save Or Update Contenedores
                    for await (const item of this.lstContenedor) {
                        if (item.Id > 0) {//Update
                            const res = await this.updateContenedor(item.Id, item.TipoContenedor, item.MatriculaContenedor, item.NumPrecinto);
                        } else { //Save
                            const res = await this.saveContenedor(item.TipoContenedor, item.MatriculaContenedor, item.NumPrecinto);
                        }
                    }
                }

                //this.FormFiguras.value.idOperacion = this.idOperacion;
                let idPais: number = CatPais.Mexico;
                let selPais = this.FormMaritimo.value.NacionalidadEmbarc || null;
                if (selPais)
                    idPais = selPais?.id || CatPais.Mexico;

                let data = {
                    data: {
                        cat_perm_sct: this.FormMaritimo.value.PermSCT,
                        numPermisoSCT: this.FormMaritimo.value.NumPermisoSCT,
                        nombreAseg: this.FormMaritimo.value.NombreAseg,
                        numPolizaSeguro: this.FormMaritimo.value.NumPolizaSeguro,
                        cat_tipo_embarcacion: this.FormMaritimo.value.TipoEmbarcacion,
                        matricula: this.FormMaritimo.value.Matricula,
                        numeroOMI: this.FormMaritimo.value.NumeroOMI,
                        anioEmbarcacion: this.FormMaritimo.value.AnioEmbarcacion,
                        nombreEmbarc: this.FormMaritimo.value.NombreEmbarc,
                        nacionalidadEmbarc: idPais,
                        unidadesDeArqBruto: this.FormMaritimo.value.UnidadesDeArqBruto,
                        cat_tipo_carga: this.FormMaritimo.value.TipoCarga,
                        numCertITC: this.FormMaritimo.value.NumCertITC,
                        eslora: this.FormMaritimo.value.Eslora,
                        manga: this.FormMaritimo.value.Manga,
                        calado: this.FormMaritimo.value.Calado,
                        lineaNaviera: this.FormMaritimo.value.Calado,
                        nombreAgenteNaviero: this.FormMaritimo.value.NombreAgenteNaviero,
                        cat_auto_naviero: this.FormMaritimo.value.NumAutorizacionNaviero,
                        numViaje: this.FormMaritimo.value.NumViaje,
                        numConocEmbarc: this.FormMaritimo.value.NumConocEmbarc,
                        fac_porte_mari_contes: this.formContenedores
                        //publishedAt: new Date()
                    }
                }
                // +++++ ADD OR UPDATE ------------
                let idTypeTransport = this.FormMaritimo.value.Transporte || 0;
                //++++++---------------------------
                if (idTypeTransport > 0) {//UPDATE
                    this.store.dispatch(MostrarSpinner());
                    this.srvcoal.putService(`fac-porte-maritimos/${idTypeTransport}`, data).subscribe(async (res: any) => {
                        //console.log("🚀 ~ MaritimoComponent ~ ******* UPDATE:", res)
                        this.store.dispatch(OcultarSpinner());
                        if (res.err) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                        } else if (res.excepcion) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                        } else {
                            //Obtenbiendo respuesta y refrescando select...
                            let result = res?.data || { id: 0 };
                            if (result?.id > 0) {
                                let idSelected = Number(result.id || 0);
                                if (idSelected > 0) {
                                    const updempresa = await this.updateEmpresaTrasportes(idSelected);
                                    const ls = await this.getCatTipoTransporte();
                                    this.f['Transporte'].setValue(idSelected);
                                }

                                this._snackBar.open("Registro Actualizado", 'Ok', { duration: 10000 });

                            } else {
                                this._snackBar.open("Ocurrió un erro al guardar información", 'Ok', { duration: 10000 });
                            }
                        }

                        resolve(true);
                    },
                        (error: any) => {
                            console.error(error);
                            resolve(false);
                        });
                } else { //ADD
                    this.store.dispatch(MostrarSpinner());
                    this.srvcoal.postService('fac-porte-maritimos', data).subscribe(async (res: any) => {
                        //console.log("🚀 ~ MaritimoComponent ~ ADD ~ res:", res)
                        this.store.dispatch(OcultarSpinner());
                        if (res.err) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                        } else if (res.excepcion) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                        } else {
                            //Obtenbiendo respuesta y refrescando select...
                            let result = res?.data || { id: 0 };
                            if (result?.id > 0) {
                                let idSelected = Number(result.id || 0);
                                if (idSelected > 0) {
                                    const updempresa = await this.updateEmpresaTrasportes(idSelected);
                                    const ls = await this.getCatTipoTransporte();
                                    this.f['Transporte'].setValue(idSelected);
                                }

                                // this.FormMaritimo.patchValue({
                                //     Transporte:idSelected
                                // });

                                this._snackBar.open("Registro Exitoso", 'Ok', { duration: 10000 });

                            } else {
                                this._snackBar.open("Ocurrió un erro al guardar información", 'Ok', { duration: 10000 });
                            }
                        }

                        resolve(true);
                    },
                        (error: any) => {
                            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                            this.store.dispatch(OcultarSpinner());
                            resolve(false);
                        });
                }

            } else {
                this._snackBar.open("Los campos marcados con asterisco (*) son requeridos", 'Ok', { duration: 8000 });
                resolve(false);
            }

        });
    }

    saveContenedor(idTipo: number = 0, matricula: string = null, num: string = null): Promise<boolean> {
        return new Promise<boolean>(resolve => {

            let data = {
                data: {
                    cat_tipo_contenedor: idTipo,
                    matriculaContenedor: matricula,
                    numPrecinto: num,
                    publishedAt: new Date()
                }
            };

            this.srvcoal.postService('fac-porte-mari-contes', data).subscribe((res: any) => {
                //console.log("🚀 ~ MaritimoComponent ~ saveContenedor~ res:", res)
                if (res?.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                } else if (res?.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }));
                } else {
                    let result = res?.data || { id: 0 };
                    if (result?.id > 0) {
                        this.formContenedores.push(result.id);
                        //return this._snackBar.open("Registro Exitoso", 'Ok', { duration: 10000 });
                    }
                    //else {
                    //return this._snackBar.open("Ocurrió un erro al guardar información", 'Ok', { duration: 10000 });
                    //}
                    //this.getFiguras();

                }

                resolve(true);
            },
                (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    resolve(false);
                });

        });

    }

    updateContenedor(id: number = 0, idTipo: number = 0, matricula: string = null, num: string = null): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            let data = {
                data: {
                    cat_tipo_contenedor: idTipo,
                    matriculaContenedor: matricula,
                    numPrecinto: num
                }
            };

            this.srvcoal.putService(`fac-porte-mari-contes/${id}`, data).subscribe((res: any) => {
                //console.log("🚀 ~ MaritimoComponent ~ updateContenedor~ res:", res)

                if (res?.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                } else if (res?.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }));
                } else {
                    let result = res?.data || { id: 0 };
                    if (result?.id > 0) {
                        this.formContenedores.push(result.id);
                        //return this._snackBar.open("Registro Exitoso", 'Ok', { duration: 10000 });
                    }
                }
                resolve(true);
            },
                (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    resolve(false);
                });

        });
    }

    logicalDeleteContenedor(idCont: number = 0): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            let model = {
                data: { publishedAt: null }
            };
            this.srvcoal.putService(`fac-porte-mari-contes/${idCont}`, model).subscribe(async (res: any) => {
                //console.log("🚀 ~ MaritimoComponent ~ logicalDeleteContenedor:", res)
                resolve(true);
            },
                (error: any) => {
                    console.error(error);
                    resolve(false);
                });

        });
    }

    logicalDeleteTipoMaritimo(idTipo: number = 0): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            let model = {
                data: { publishedAt: null }
            };
            this.srvcoal.putService(`fac-porte-maritimos/${idTipo}`, model).subscribe((res: any) => {
                //console.log("🚀 ~ MaritimoComponent ~ logicalDeleteTipoMaritimo:", res)
                resolve(true);
            },
                (error: any) => {
                    console.error(error);
                    resolve(false);
                });

        });
    }

    updateEmpresaTrasportes(newId: number = 0): Promise<boolean> {
        return new Promise<boolean>(resolve => {

            const ids: number[] = this.tipoTransporte.map(o => o.id) || [];
            if (newId > 0)
                ids.push(newId);

            const model = {
                data: {
                    fac_porte_maritimos: ids
                }
            };
            this.store.dispatch(MostrarSpinner());
            this.srvcoal.putService(`ope-empresas/${this.idEmpresa}`, model).subscribe((por: any) => {
                this.store.dispatch(OcultarSpinner());
                resolve(true);
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this._snackBar.open(`Ocurrió un error al guardar el transporte maritimo ${error?.error?.error?.message}`, "OK", { duration: 5000 });
                resolve(false);
            });
        });
    }

    getMaritimoSeleccionado(idTransporte: number = 0) {
        this.countContenedor = [];
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`fac-porte-maritimos/${idTransporte}?populate=cat_perm_sct,cat_tipo_embarcacion,nacionalidadEmbarc,cat_tipo_carga,cat_auto_naviero,fac_porte_mari_contes.cat_tipo_contenedor`).subscribe(
            (res: any) => {
                //console.log("🚀 ~ MaritimoComponent ~ getMaritimoSeleccionado ~ res:", res)
                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {

                    let model = res?.data || {};
                    //Set Model
                    if (model?.id) {

                        let cat_perm_sct = model?.attributes?.cat_perm_sct || {};
                        let idCatPerm = cat_perm_sct?.data?.id || null;

                        let cat_tipo_embarcacion = model?.attributes?.cat_tipo_embarcacion || {};
                        let idCatTipo = cat_tipo_embarcacion?.data?.id || null;
                        //Paises Change
                        let nacionalidadEmbarc = model?.attributes?.nacionalidadEmbarc || {};
                        let nacionalidad = nacionalidadEmbarc?.data || {};
                        let selPais: any;
                        if (nacionalidad?.id) {
                            selPais = this.paises.find(x => x.id == nacionalidad.id);
                        } else {
                            selPais = this.paises?.find(x => x.id == CatPais.Mexico);
                        }

                        let cat_tipo_carga = model?.attributes?.cat_tipo_carga || {};
                        let idCatTipoCarga = cat_tipo_carga?.data?.id || null;

                        let cat_auto_naviero = model?.attributes?.cat_auto_naviero || {};
                        let idNaviero = cat_auto_naviero?.data?.id || null;
                        //Set form
                        this.FormMaritimo.patchValue({
                            PermSCT: idCatPerm,
                            NumPermisoSCT: model?.attributes?.numPermisoSCT || null,
                            NombreAseg: model?.attributes?.nombreAseg || null,
                            NumPolizaSeguro: model?.attributes?.numPolizaSeguro || null,
                            TipoEmbarcacion: idCatTipo,
                            Matricula: model?.attributes?.matricula || null,
                            NumeroOMI: model?.attributes?.numeroOMI || null,
                            AnioEmbarcacion: model?.attributes?.anioEmbarcacion || null,
                            NombreEmbarc: model?.attributes?.nombreEmbarc || null,
                            NacionalidadEmbarc: selPais || null,
                            UnidadesDeArqBruto: model?.attributes?.unidadesDeArqBruto || null,
                            TipoCarga: idCatTipoCarga || null,
                            NumCertITC: model?.attributes?.numCertITC || null,
                            Eslora: model?.attributes?.eslora || null,
                            Manga: model?.attributes?.manga || null,
                            Calado: model?.attributes?.calado || null,
                            LineaNaviera: model?.attributes?.lineaNaviera || null,
                            NombreAgenteNaviero: model?.attributes?.nombreAgenteNaviero || null,
                            NumAutorizacionNaviero: idNaviero || null,
                            NumViaje: model?.attributes?.numViaje || null,
                            NumConocEmbarc: model?.attributes?.numConocEmbarc || null,
                        });

                        //Set fac_porte_mari_contes
                        //Existe contenedores
                        const myContenedores: any[] = model?.attributes?.fac_porte_mari_contes?.data || [];
                        //console.log("🚀 ~ MaritimoComponent ~ myContenedores:", myContenedores)
                        // Object.keys(myContenedores).forEach((index, item:any) => {
                        //     console.log("🚀 ~ MaritimoComponent ~ Object.keys ~ item:", item)                                                     
                        // });
                        for (const { id, attributes } of myContenedores) {
                            let key = Number(id || 0);
                            if (key) {
                                let type = Number(attributes?.cat_tipo_contenedor?.data?.id || 0);
                                let matric = attributes?.matriculaContenedor || null;
                                let numPrec = attributes?.matriculaContenedor || null;
                                let element: IContenedorMaritimo = { Index: '', Id: key, TipoContenedor: type, MatriculaContenedor: matric, NumPrecinto: numPrec };
                                this.addContenedor(element);
                            }
                        }

                    }
                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

}
